import { CumulativeRainfallDTO } from './CumulativeRainfallDTO'
import { CumulativeRainfallRaw } from './SettingRaw'

export class CumulativeRainfallDTOFactory {
  static fromRaw(raw: CumulativeRainfallRaw): CumulativeRainfallDTO {
    return new CumulativeRainfallDTO(raw.cumulative_time_minutes, raw.cumul_aggregation_time_minutes)
  }
}
